<template>
  <div class="panel-body">
    <v-flex xs12>
      <v-card v-model="myjar">
        <v-layout>
          <v-flex xs1>
            <v-img v-bind:src="this.jar.imageUrl" height="125px" contain></v-img>
          </v-flex>
          <v-flex xs7>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ formTitle }}</div>
                <div>{{this.jar.categoryName}}</div>
                <div>${{this.jar.received}} of ${{this.jar.goal}} saved</div>
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>

        <div>
          <v-tabs slot="extension" v-model="model" color="blue" slider-color="yellow">
            <v-tab :key="jarDetailTab">Details</v-tab>
            <v-tab v-if="jar.typeCode=='group-saving'" :key="jarMemberTab">Members</v-tab>
            <v-tab v-if="jar.typeCode=='group-saving'" :key="jarConfigureTab">Withdrawals</v-tab>
            <v-tab :key="jarHistoryTab">History</v-tab>
            <v-tab :key="jarAddFundsTab">Add Funds</v-tab>
            <v-tab :key="jarRulesTab">Rules</v-tab>
            <v-tab :key="jarActionHistoryTab">Action History</v-tab>
          </v-tabs>
          <v-spacer></v-spacer>
          <v-tabs-items v-model="model">
            <v-tab-item :key="jarDetailTab">
              <jarDetail ref="jarDetailRef" v-bind:user="this.user"></jarDetail>
            </v-tab-item>
            <v-tab-item v-if="jar.typeCode=='group-saving'" :key="jarMemberTab">
              <jarMember
              ref="jarmemberRef"
              v-bind:userId="this.user.userId"
                v-bind:jarId="this.jar.id"
                ></jarMember>
              </v-tab-item>
              <v-tab-item v-if="jar.typeCode=='group-saving'" :key="jarConfigureTab">
              <jarConfigure
              ref="jarConfigureRef"
              v-bind:userId="this.user.userId"
                v-bind:jarId="this.jar.id"
                ></jarConfigure>
              </v-tab-item>
            <v-tab-item :key="jarHistoryTab">
              <jarHistory
                ref="jarHistoryRef"
                v-bind:userId="this.user.userId"
                v-bind:jarId="this.jar.id"
              ></jarHistory>
            </v-tab-item>
            <v-tab-item eager :key="jarAddFundsTab">
              <jarAddFunds
                ref="jarAddFundsRef"
                eager
                v-bind:user="this.user"
                v-bind:jar="this.jar"
                @save-add-funds="fundsAdded"
              ></jarAddFunds>
            </v-tab-item>
            <v-tab-item eager :key="jarRulesTab">
              <jarRules
                ref="jarRulesRef"
                eager
                v-bind:jarId="this.jar.id"
                v-on:open-rule="$emit('open-rule', $event)"
              ></jarRules>
            </v-tab-item>
            <v-tab-item eager :key="jarActionHistoryTab">
              <jarActionHistory
                ref="jarActionHistoryRef"
                v-bind:jarId="this.jar.id"
              ></jarActionHistory>
            </v-tab-item>
          </v-tabs-items>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import jarActionHistory from '@/components/jar/JarActionHistory.vue'
import jarHistory from '@/components/JarHistory.vue'
import jarDetail from '@/components/JarDetails.vue'
import jarAddFunds from '@/components/JarAddFundsDialog.vue'
import jarRules from '@/components/JarRules.vue'
import jarMember from '@/components/jarMember.vue'
import jarConfigure from '@/components/jarConfigure.vue'

let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    jar: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    activeTab: {
      required: false,
      default: 0
    }
  },
  data: () => ({
    userId: '',
    myjar: false,
    search: '',
    model: null,
    rppItems: [
      10,
      25,
      50,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    errors: [],
    jarActionHistoryTab: null,
    jarHistoryTab: null,
    jarDetailTab: null,
    jarMemberTab: null,
    jarConfigureTab: null,
    jarAddFundsTab: null,
    jarRulesTab: null,
    headers: [
      { text: 'Jar ID', align: 'left', value: 'id' },
      { text: 'Name', value: 'name' },
      { text: 'Category', value: 'categoryName' },
      { text: 'Saved', align: 'right', value: 'received' },
      { text: 'Goal', align: 'right', value: 'goal' },
      { text: 'Status', align: 'center', value: 'status' }
      // ,
      // { text: 'Created', align: 'center', value: 'wishlist.createdDate' }
    ]
  }),
  computed: {
    formTitle () {
      if (
        this.user === undefined ||
        this.user == null ||
        this.jar === undefined ||
        this.jar == null
      ) {
        return 'Jar'
      } else {
        return (
          this.jar.name +
          ' Jar for ' +
          this.user.firstName +
          ' ' +
          this.user.lastName
        )
      }
    }
  },
  watch: {
    activeTab: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.model = newValue
      }
    }
  },
  created () {},
  mounted () {
    this.model = this.activeTab
  },
  components: {
    jarActionHistory,
    jarHistory,
    jarDetail,
    jarMember,
    jarConfigure,
    jarAddFunds,
    jarRules
  },
  methods: {
    close () {
      if (this.$refs.jarHistoryRef) {
        this.$refs.jarHistoryRef.history = []
      }
      if (this.$refs.jarAddFundsRef) this.$refs.jarAddFundsRef.initialize()
      this.model = 0
      this.$emit('close-jar')
    },
    // hasWishlist () {
    //   return !(
    //     this.jar === undefined ||
    //     this.jar == null ||
    //     this.jar.wishlist == null
    //   )
    // },
    loadJarDetails () {},
    fundsAdded () {
      this.$emit('fundsadded-jar')
      this.close()
      this.model = 0
    }
  }
}
</script>
<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>
